module.exports = __webpack_public_path__ + "static/img/04-09.653b64a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/04-09.png
// module id = n2oX
// module chunks = 0